export const FEATURE_FLAGS = {
  WEB_9731_INVOICE_ADDRESS_V2: "WEB-9731-invoice-address-v2",
  WEB_10382_AIRPORT_SEAPORT_ADDRESS: "WEB-10382-airport-seaport-address",
  FF_WEB10382_OPTIONAL_PORT_ADDRESS_FORM: "ff_web10382_optional_port_address_form",
  FF_WEB10382_PORT_ADDRESS_DETAIL_RENDERING: "ff_web10382_port_address_detail_rendering",
  FF_WEB10382_HEADER_PORT_LABELING: "ff_web10382_header_port_labeling",
  WEB_10723_INTERCOM_CHAT: "WEB-10723-intercom-chat",
  WEB_10959_MULTISTOP_POD: "WEB-10959-multistop-pod",
  WEB_10502_SHIPMENT_DETAILS_REVAMP: "WEB-10502-shipment-details-revamp",
  WEB_11220_QUICK_REQUEST_V2: "WEB-11220-quick-request-v2",
  WEB_11070_TRACKING_NUMBER_REVAMP: "WEB-11070-tracking-number-revamp",
  WEB_10988_EDIT_DELIVERED_SHIPMENT_ORGANIZATION: "WEB-10988-edit-delivered-shipment-organization",
} as const;

export type FeatureFlagKey = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];
